export const DAY_ID_TO_LABEL: Record<string, string> = {
  sunday: 'Domingo',
  monday: 'Lunes',
  tuesday: 'Martes',
  wednesday: 'Miércoles',
  thursday: 'Jueves',
  friday: 'Viernes',
  saturday: 'Sábado',
};

export const DAY_INDEX_TO_NAME: Record<number, string> = {
  0: 'sunday',
  1: 'monday',
  2: 'tuesday',
  3: 'wednesday',
  4: 'thursday',
  5: 'friday',
  6: 'saturday',
};

export type DealStatus = 'Aprobada' | 'Pendiente' | 'Finalizada' | 'Rechazada';

export interface SubmitDealPayload {
  name: string;
  experienceId: number;
  discountPercent: number;
  days: string[];
  startDate: Date;
  endDate: Date;
}

export interface SubmitDealResponse {
  ok: boolean;
  errors?: string[];
}

export interface DealListItem {
  id: string;
  name: string;
  experience: string;
  discountPercent: number;
  days: string[];
  startDate: Date;
  endDate: Date;
  discountedRate: number;
  status: DealStatus;
}

export interface DiscountDayApi {
  id: string;
  value: string;
}

export interface DiscountStatusApi {
  id: string;
  value: string;
}

export interface DiscountApi {
  id: string;
  name: string;
  activity_id: number;
  date_begin: string;
  date_end: string;
  days: DiscountDayApi[];
  discount_percentage: string;
  status: DiscountStatusApi;
  price_applied: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  activity: {
    id: number;
    internal_name: string;
    name: string;
    partner: {
      id: number;
      fantasy_name: string;
      account_executive: string;
    };
  };
}

export interface CreateDiscountPayload {
  name: string;
  activity_id: number;
  date_begin: string;
  date_end: string;
  days: string[];
  discount_percentage: number;
}
